import Transition, {
	TRANSITION_DURATION_MS,
	TRANSITION_SLIDE_DURATION_MS,
} from './transition'

export { TRANSITION_DURATION_MS, TRANSITION_SLIDE_DURATION_MS }
export default Transition
